import { render, staticRenderFns } from "./contentList.vue?vue&type=template&id=fd4cdfd6&scoped=true"
import script from "./contentList.vue?vue&type=script&lang=js"
export * from "./contentList.vue?vue&type=script&lang=js"
import style0 from "./contentList.vue?vue&type=style&index=0&id=fd4cdfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4cdfd6",
  null
  
)

export default component.exports